import { render, staticRenderFns } from "./levelsReferences.vue?vue&type=template&id=7a34d560"
import script from "./levelsReferences.vue?vue&type=script&lang=js"
export * from "./levelsReferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports